export default __webpack_public_path__ + "static/media/mobile-dev-cross.e5e99fc0.png";